// extracted by mini-css-extract-plugin
export default {"notes":"NotesColumn_notes__Y44--"};